import { render } from "./AdList.vue?vue&type=template&id=06772aa3&ts=true"
import script from "./AdList.vue?vue&type=script&lang=ts"
export * from "./AdList.vue?vue&type=script&lang=ts"

import exportComponent from "F:\\agent009\\_work\\569\\s\\sites\\easyestate\\easyestate.front\\ClientApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__